module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusives-2-a9733d454fc3c5a58f9900631bc787da.jpg";